import { render, staticRenderFns } from "./NewCustomersComponent.vue?vue&type=template&id=1a3dabee"
import script from "./NewCustomersComponent.vue?vue&type=script&lang=js"
export * from "./NewCustomersComponent.vue?vue&type=script&lang=js"
import style0 from "./NewCustomersComponent.vue?vue&type=style&index=0&id=1a3dabee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports